import { z } from "zod";
import { NpdCalculationState } from "../npd-calculation-state";
import { npdCalculationResultsDtoSchema } from "./npd-calculation-results.schema";
export const npdCanceledCalculationStatusDtoSchema = z.object({
    state: z.literal(NpdCalculationState.Canceled),
    partialResults: npdCalculationResultsDtoSchema,
});
